import { render, staticRenderFns } from "./EditImportTable.vue?vue&type=template&id=564f5119&scoped=true&"
import script from "./EditImportTable.vue?vue&type=script&lang=js&"
export * from "./EditImportTable.vue?vue&type=script&lang=js&"
import style0 from "./EditImportTable.vue?vue&type=style&index=0&id=564f5119&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564f5119",
  null
  
)

export default component.exports